import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces'

export interface InsightInputsReducerI {
    selectedConfig: {
        label: string
        value: string
    } | null
    selectedDateRange: string[]
}

const initialState: InsightInputsReducerI = {
    selectedConfig: null,
    selectedDateRange: [],
}

const insightReportReducer = (state = initialState, action: ActionExtended) => {
    if (action.type === ACTIONS.SET_INSIGHT_INPUTS) {
        return {
            ...state,
            ...action.payload,
        }
    }
    return state
}

export default insightReportReducer
